import MetaContent from '../components/MetaContent'
import FormHeader from '../components/shared/FormHeader'
import {
  attributes,
  react as MarkdownContent,
} from '../content/terms-and-conditions.md'

export default function TermsAndConditions() {
  const { metaTitle, metaDescription, title } = attributes

  return (
    <>
      <MetaContent title={metaTitle} description={metaDescription} />

      <main>
        <section className="px-4 py-12 m-auto max-w-screen-2xl md:px-11 lg:py-20">
          <FormHeader title={title}>
            <MarkdownContent />
          </FormHeader>
        </section>
      </main>
    </>
  )
}
